<template>
  <v-container fluid class="pa-0">
    <v-row align="center" class="mt-n2 mb-2" dense>
      <v-col cols="12" sm="6" md="7">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          v-model="search"
          label="Buscar contenedores..."
          clearable
          dense
          outlined
          hide-details
          class="white rounded-lg"
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="5" class="text-end d-flex justify-end align-center">
        <v-btn color="primary" rounded small class="mr-2" @click="fetchData" elevation="0">
          <v-icon :left="!$vuetify.breakpoint.xsOnly"> mdi-refresh </v-icon>
          <span v-if="!$vuetify.breakpoint.xsOnly">Refrescar</span>
        </v-btn>
        <v-btn
          color="secondary"
          rounded
          small
          elevation="0"
          @click="openGenerateQRModal()"
        >
          <v-icon :left="!$vuetify.breakpoint.xsOnly"> mdi-printer </v-icon>
          <span v-if="qrSelected.length != 0">
            QRs ({{ qrSelected.length }})
          </span>
          <span v-else-if="!$vuetify.breakpoint.xsOnly"> Generar QRs </span>
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="mt-n4">
      <v-col>
        <template v-if="$vuetify.breakpoint.xsOnly">
          <v-container class="pa-2 px-0 bg-app">
            <v-row dense>
              <v-col
                cols="12"
                v-for="item in containers"
                :key="item._id"
                class="mb-2"
              >
                <v-card elevation="1" class="rounded-xl pa-4" :class="{'grey lighten-4': qrSelected.some(q => q._id === item._id)}">
                  <div class="d-flex justify-space-between align-start mb-2">
                    <div class="d-flex align-center">
                      <v-checkbox
                        :input-value="qrSelected.some(q => q._id === item._id)"
                        @change="(val) => {
                          if(val) qrSelected.push(item);
                          else qrSelected = qrSelected.filter(q => q._id !== item._id);
                        }"
                        hide-details
                        class="mt-0 pt-0 mr-2"
                        color="primary"
                      ></v-checkbox>
                      <div class="text-subtitle-1 font-weight-bold grey--text text--darken-4 line-height-tight">
                        {{ item.code }}
                      </div>
                    </div>
                    <v-chip
                      small
                      color="primary"
                      text-color="white"
                      class="font-weight-bold px-2"
                      style="height: 20px;"
                    >
                      {{ getStatus(item.status) }}
                    </v-chip>
                  </div>

                  <v-divider class="my-2"></v-divider>

                  <v-row dense class="text-caption">
                    <v-col cols="6" class="py-1">
                      <div class="grey--text">Fecha de creación</div>
                      <div class="font-weight-medium">
                        {{ getDateFormatted(item.createdAt) }}
                      </div>
                    </v-col>
                    <v-col cols="6" class="py-1">
                      <div class="grey--text">Última actualización</div>
                      <div class="font-weight-medium">
                        {{ getDateFormatted(item.updatedAt) }}
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <v-data-table
          v-else
          width="100%"
          :height="$vuetify.breakpoint.smAndDown ? 'auto' : `calc(100vh - 380px)`"
          :headers="headers"
          :items="containers"
          fixed-header
          :items-per-page="10"
          no-data-text="No hay qr's"
          loading-text="Cargando qr's..."
          :page.sync="page"
          hide-default-footer
          :loading="fetchingData"
          item-key="_id"
          show-select
          v-model="qrSelected"
        >
          <template v-slot:item.status="{ item }">
            {{ getStatus(item.status) }}
          </template>
          <template v-slot:item.createdAt="{ item }">
            {{ getDateFormatted(item.createdAt) }}
          </template>
          <template v-slot:item.updatedAt="{ item }">
            {{ getDateFormatted(item.updatedAt) }}
          </template>
        </v-data-table>
        <v-pagination
          v-model="page"
          :length="numPages"
          total-visible="10"
          color="primary"
          class="mt-n2"
        ></v-pagination>
      </v-col>
    </v-row>
    <GenerateQrModal
      v-if="showGenerateQrModal"
      v-model="showGenerateQrModal"
      @fetchData="closeGenerateQRModal"
    />
  </v-container>
</template>

<script>
//Vuex
import { mapActions, mapState, mapMutations } from "vuex";
//Libraries
import dayjs from "dayjs";
//axios
import axios from "axios";
//components
import GenerateQrModal from "@/components/logistic/modals/GenerateQrModal";

export default {
  components: {
    GenerateQrModal,
  },
  data: () => ({

    containers: [],
    fetchingData: false,
    page: 1,
    numPages: 0,
    search: null,
    user: JSON.parse(localStorage.getItem("user")),
    qrSelected: [],
    showGenerateQrModal: false,
    // Filter
    filterDialog: false,
    crop_items: [],
    sampleType: [
      {
        text: "Suelo compuesto",
        value: "CLASSIC",
      },
      {
        text: "Vegetal",
        value: "MAS_VEGETABLE",
      },
      {
        text: "Vegetal sin georeferencia",
        value: "VEGETABLE",
      },
      {
        text: "Composta",
        value: "COMPOST",
      },
      {
        text: "Producto",
        value: "PRODUCT",
      },
      {
        text: "Sustrato",
        value: "SUBSTRATUM",
      },
      {
        text: "Suelo sin asesor",
        value: "NO_ADVISOR",
      },
      {
        text: "Suelo compuesto",
        value: "CLASSIC",
      },
    ],
    analysisType: [
      {
        text: "Inicial",
        value: "INITIAL",
      },
      {
        text: "Seguimiento",
        value: "MONITORING",
      },
    ],
    sampleStatus: [
      {
        text: "Muestreada",
        value: "VALIDATED",
      },
      {
        text: "Muestreo en progreso",
        value: "IN_PROGRESS",
      },
    ],
    guideTypes: [
      {
        text: "Sin datos de guía",
        value: "NOT_DATA",
      },
      {
        text: "Datos parciales de guía",
        value: "PARTIAL_DATA",
      },
      {
        text: "Con datos de guía",
        value: "WITH_DATA",
      },
    ],
    form: {
      cropCycle: null,
      sampleType: null,
      analysisType: null,
    },
    // Filter
  }),
  async mounted() {
    this.setCropItems();
    await this.fetchData();
  },
  computed: {
    ...mapState("reception", ["crops"]),
    ...mapState(["cancelToken"]),
    ...mapState("session", ["authenticatedUser"]),
    headers() {
      return [
        { text: "QR", value: "code", sortable: false },
        { text: "Estatus", value: "status", sortable: false },
        { text: "Fecha creación", value: "createdAt", sortable: false },
        { text: "Fecha actualización", value: "updatedAt", sortable: false },
      ];
    },
  },
  methods: {
    ...mapMutations(["SET_CANCEL_TOKEN"]),
    ...mapActions("container", ["getContainers"]),
    ...mapMutations("container", ["SET_QR_TO_PRINT"]),
    ...mapMutations("reception", ["SET_GUIDE", "CAN_UPDATE_GUIDE"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    async fetchData() {
      this.fetchingData = true;
      try {
        if (typeof this.cancelToken != "undefined") {
          this.cancelToken.cancel("Operation canceled due to new request.");
        }
        //Save the cancel token for the current request
        this.SET_CANCEL_TOKEN(axios.CancelToken.source());
        let payload = {
          search: this.search,
          //   filter: this.form,
          page: this.page,
          // laboratory: this.user.laboratory._id,
        };
        let response = await this.getContainers(payload);
        //hide loaders
        this.fetchingData = false;
        //set sample data
        this.containers = response.containers;
        this.numPages = response.pages;
      } catch (e) {
        //print log
        console.log(e);
        //hide loaders
        this.fetchingData = false;
        //show error to user
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal cargar muestras en transito, intente de nuevo !!",
          timeout: 5000,
        });
      }
    },
    getStatus(value) {
      let status = {
        UNREGISTERED: "Sin registro",
        REGISTERED: "registrado",
      };
      return status[value];
    },
    setCropItems() {
      let cropsArray = Object.entries(this.crops);
      for (let crop of cropsArray) {
        this.crop_items.push({
          text: crop[1],
          value: crop[0],
        });
      }
    },
    getCrop(value) {
      let template = "";
      const crop = {
        olive: "Aceituna",
        chard: "Acelga",
        achiote: "Achiote",
        agave: "Agave",
        avocado: "Aguacate",
        garlic: "Ajo",
        sesame: "Ajonjolí",
        basil: "Albahaca",
        artichoke: "Alcachofa",
        alcatraz: "Alcatraz",
        shrunkenAlfalfa: "Alfalfa achicalada",
        greenAlfalfa: "Alfalfa verde",
        cotton: "Algodón",
        almond: "Almendro",
        birdseed: "Alpiste",
        amaranth: "Amaranto",
        anise: "Anís",
        celery: "Apio",
        blueberry: "Arándano",
        myrtle: "Arrayán",
        rice: "Arroz",
        greenForageOats: "Avena forrajera en verde",
        oatGrain: "Avena grano",
        bamboo: "Bambú",
        eggplant: "Berenjena",
        beetroot: "Betabel",
        broccoli: "Brocoli",
        peanut: "Cacahuate",
        cocoa: "Cacao",
        cherryCoffee: "Café cereza",
        pumpkin: "Calabaza",
        sweetPotato: "Camote",
        sugarCane: "Caña de azúcar",
        canola: "Canola",
        carambolo: "Carambolo",
        safflower: "Cártamo",
        barley: "Cebada",
        greenForageBarley: "Cebada forrajera en verde",
        onion: "Cebolla",
        chives: "Cebollín",
        ryeGrain: "Centeno grano",
        cherry: "Cereza",
        chabacano: "Chabacano",
        pea: "Chícharo",
        squash: "Chayote",
        chia: "Chía",
        chilacayote: "Chilacayote",
        chillyPepper: "Chile / Pimiento",
        custardApple: "Chirimoya",
        coriander: "Cilantro",
        plum: "Ciruela",
        coconutFruit: "Coco fruta",
        cabbage: "Col (repollo)",
        brusselsSprouts: "Col de Bruselas",
        cauliflower: "Coliflor",
        cumin: "Comino",
        chrysanthemum: "Crisantemo (planta)",
        peach: "Durazno",
        date: "Dátil",
        greenBean: "Ejote",
        cornCob: "Elote",
        dill: "Eneldo",
        epazote: "Epazote",
        asparagus: "Espárrago",
        spicesAndMedicinals: "Especias y medicinales",
        spinach: "Espinaca",
        raspberry: "Frambuesa",
        strawberry: "Fresa",
        bean: "Frijol",
        chickpea: "Garbanzo",
        sunflower: "Girasol",
        pomegranate: "Granada",
        soursop: "Guanábana",
        guava: "Guayaba",
        henequen: "Henequén",
        peppermint: "Hierbabuena",
        aromaticHerbs: "Hierbas aromáticas",
        fig: "Higo",
        jamaica: "Jamaica",
        ginger: "Jenjibre",
        jicama: "Jícama",
        lettuce: "Lechuga",
        lentil: "Lenteja",
        lime: "Lima",
        lemon: "Limón",
        linseed: "Linaza",
        litchi: "Litchi",
        corn: "Maíz",
        macadamia: "Macadamia",
        maguey: "Maguey",
        mamey: "Mamey",
        tangerine: "Mandarina",
        mango: "Mango",
        mangosteen: "Mangostán",
        chamomile: "Manzanilla",
        appleTree: "Manzano",
        passionFruit: "Maracuyá",
        daisyFlower: "Margarita",
        marjoram: "Mejorana",
        melon: "Melón",
        quince: "Membrillo",
        mint: "Menta",
        moringa: "Moringa",
        turnip: "Nabo",
        nanche: "Nanche",
        napa: "Napa",
        orange: "Naranja",
        medlar: "Níspero",
        nochebuena: "Nochebuena (planta)",
        walnut: "Nogal",
        noni: "Noni",
        nopal: "Nopal",
        oregano: "Orégano",
        ornamental: "Ornamentales",
        orchid: "Orquídea (planta)",
        oilPalm: "Palma africana o de aceite",
        potato: "Papa",
        papaya: "Papaya",
        grasslands: "Pastizales",
        matGrass: "Pasto tapete (m2)",
        pasturesAndMeadows: "Pastos y praderas",
        cucumber: "Pepino",
        pearTree: "Peral",
        parsley: "Perejil",
        peron: "Perón",
        persimony: "Persimonio",
        pepper: "Pimienta",
        pineapple: "Piña",
        pinion: "Piñón",
        pistache: "Pistache",
        pitaya: "Pitaya",
        banana: "Plátano",
        pore: "Poro",
        radish: "Rábano",
        rambutan: "Rambután",
        romerito: "Romerito",
        rosemary: "Romero",
        aloe: "Sábila",
        watermelon: "Sandía",
        sorghum: "Sorgo",
        soy: "Soya",
        stevia: "Stevia",
        tobacco: "Tabaco",
        tamarind: "Tamarindo",
        tejocote: "Tejocote",
        tomato: "Tomate Rojo (jitomate)",
        greenTomato: "Tomate Verde",
        thyme: "Tomillo",
        grapefruit: "Toronja (pomelo)",
        clover: "Trébol",
        wheat: "Trigo",
        dutchTulip: "Tulipán holandés",
        tuna: "Tuna",
        grape: "Uva",
        vanilla: "Vainilla",
        purslane: "Verdolaga",
        vine: "Vid",
        cassavaFood: "Yuca alimenticia",
        carrot: "Zanahoria",
        sapodilla: "Zapote",
        blackberry: "Zarzamora",
        zempoalxochitl: "Zempoalxochitl",
        fallow: "Barbecho",
        other: "Otro",
      };
      let cropName = crop[value];
      if (cropName) {
        template = cropName;
      } else {
        template = "Sin cultivo";
      }
      return template;
    },
    getDateFormatted(value) {
      const date = `${dayjs(value).format("D/M/YYYY - HH:mm")} hrs`;
      return date ? date : "----";
    },
    getSampleType(value) {
      console.log(value);
      const types = {
        CLASSIC: "Suelo compuesto",
        MAS: "Muestra para genómica",
        MAS_VEGETABLE: "Vegetal",
        VEGETABLE: "Vegetal sin georeferencia",
        COMPOST: "Composta",
        PRODUCT: "Producto",
        SUBSTRATUM: "Sustrato",
        NO_ADVISOR: "Suelo sin asesor",
      };
      if (value) {
        let temp = types[value];
        return temp;
      } else {
        return "";
      }
    },
    getAnalysisType(value) {
      if (value == "INITIAL" || value == "Initial") {
        return "Inicial";
      } else {
        return "Seguimiento";
      }
    },
    async applyFilters() {
      this.filterDialog = false;
      this.page = 1;
      await this.fetchData();
    },
    async cleanFilters() {
      this.search = null;
      this.filterDialog = false;
      this.form = {
        cropCycle: null,
        sampleType: null,
        analysisType: null,
      };
      await this.fetchData();
    },
    openGenerateQRModal() {
      this.SET_QR_TO_PRINT(this.qrSelected);
      this.showGenerateQrModal = true;
    },
    async closeGenerateQRModal() {
      this.page = 1;
      this.SET_QR_TO_PRINT([]);
      this.showGenerateQrModal = false;
      this.qrSelected = [];
      await this.fetchData();
    },
  },
  watch: {
    async search() {
      this.page = 1;
      await this.fetchData();
    },
    async page() {
      //   if (this.page != parseInt(this.$route.params.page)) {
      //   this.$router.replace({
      //     params: {
      //       page: this.page,
      //     },
      //   });
      // }
      await this.fetchData();
    },
  },
};
</script>

<style scoped></style>
